import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { motion } from 'framer-motion';
import axios from 'axios';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLoginPage = () => {
  const { t, login } = useApp();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const { data } = await axios.post(`${BACKEND_URL}/api/auth/login`, formData);
      login(data.token, { username: data.username });
      toast.success('Login successful!');
      navigate('/admin');
    } catch (error) {
      toast.error('Invalid credentials');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="glass p-12 w-full max-w-md"
      >
        <h1 className="text-3xl font-serif mb-2 text-center">{t('login')}</h1>
        <p className="text-sm text-muted-foreground text-center mb-8">{t('admin')} Panel</p>

        <form onSubmit={handleSubmit} data-testid="login-form" className="space-y-6">
          <div>
            <input
              type="text"
              data-testid="login-username"
              placeholder={t('username')}
              value={formData.username}
              onChange={(e) => setFormData({ ...formData, username: e.target.value })}
              required
              className="w-full bg-transparent border-b border-white/20 py-3 text-sm focus:outline-none focus:border-primary transition-colors placeholder:text-white/30"
            />
          </div>
          <div>
            <input
              type="password"
              data-testid="login-password"
              placeholder={t('password')}
              value={formData.password}
              onChange={(e) => setFormData({ ...formData, password: e.target.value })}
              required
              className="w-full bg-transparent border-b border-white/20 py-3 text-sm focus:outline-none focus:border-primary transition-colors placeholder:text-white/30"
            />
          </div>
          <button
            type="submit"
            data-testid="login-submit"
            disabled={loading}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90 px-6 py-4 font-serif text-sm uppercase tracking-wider transition-all disabled:opacity-50"
          >
            {loading ? '...' : t('login')}
          </button>
        </form>
      </motion.div>
    </div>
  );
};

export default AdminLoginPage;